import { __extends } from "tslib";
import { ImageTextureCube } from "./ImageTextureCube";
var ShadowTextureCube = /** @class */ (function (_super) {
    __extends(ShadowTextureCube, _super);
    function ShadowTextureCube(mapper, image) {
        if (image === void 0) { image = null; }
        var _this = _super.call(this, image) || this;
        _this._mapper = mapper;
        return _this;
    }
    Object.defineProperty(ShadowTextureCube.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return ShadowTextureCube.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowTextureCube.prototype, "mapper", {
        get: function () {
            return this._mapper;
        },
        enumerable: true,
        configurable: true
    });
    ShadowTextureCube.assetType = "[texture ShadowTextureCube]";
    return ShadowTextureCube;
}(ImageTextureCube));
export { ShadowTextureCube };
import { ShaderBase } from "@awayjs/renderer";
import { _Shader_DepthTexture } from "./DepthTextureCube";
/**
 *
 * @class away.pool._Shader_DepthTexture
 */
var _Shader_ShadowTextureCube = /** @class */ (function (_super) {
    __extends(_Shader_ShadowTextureCube, _super);
    function _Shader_ShadowTextureCube() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_ShadowTextureCube.prototype._getFragmentCode = function (targetReg, regCache, sharedRegisters, inputReg) {
        var posReg = regCache.getFreeFragmentConstant();
        this._positionIndex = posReg.index * 4;
        var epsReg = regCache.getFreeFragmentConstant();
        var code = "";
        var lightDir = regCache.getFreeFragmentVectorTemp();
        code += "sub " + lightDir + ", " + inputReg + ", " + posReg + "\n" +
            "dp3 " + lightDir + ".w, " + lightDir + ".xyz, " + lightDir + ".xyz\n" +
            "nrm " + lightDir + ".xyz, " + lightDir + ".xyz\n";
        code += _super.prototype._getFragmentCode.call(this, targetReg, regCache, sharedRegisters, lightDir) +
            "add " + lightDir + ".w, " + lightDir + ".w, " + epsReg + ".x\n" + // offset by epsilon (add 2*light*epsilon)?
            "mul " + lightDir + ".w, " + lightDir + ".w, " + posReg + ".w\n" + // divide by falloff squared to normalise
            "slt " + targetReg + ".w, " + lightDir + ".w, " + targetReg + ".w\n"; // 0 if in shadow
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowTextureCube.prototype._activate = function () {
        _super.prototype.activate.call(this);
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._positionIndex;
        var pos = this._texture.mapper.light.transform.concatenatedMatrix3D.position;
        var fallOff = this._texture.mapper.light.fallOff; // used to decompress distance
        fragmentData[index] = pos.x;
        fragmentData[index + 1] = pos.y;
        fragmentData[index + 2] = pos.z;
        fragmentData[index + 3] = 1 / (2 * fallOff * fallOff); //TODO: do we need the 2?
        //epsilon
        fragmentData[index + 4] = -Math.pow(1 / (fallOff * this._texture.mapper.epsilon), 2);
    };
    return _Shader_ShadowTextureCube;
}(_Shader_DepthTexture));
export { _Shader_ShadowTextureCube };
ShaderBase.registerAbstraction(_Shader_ShadowTextureCube, ShadowTextureCube);
